export default "__VITE_ASSET__adInBRp1__"